export type PFEntities =
    | PFCoreEntities
    | PFLoadEntities
    | PFTransportationEntities
    | PFItemCatalogEntities
    | PFCommunicationsEntities
    | PFWmsEntities;

export enum PFCoreEntities {
    Carrier = 'Carriers',
    Contact = 'Contacts',
    Vendor = 'Vendors',
    Customer = 'Customers',
    Location = 'Locations',
    User = 'Users',
    UserRole = 'UserRoles',
    Timezone = 'Timezones',
    UserPermission = 'UserPermissions',
    FiscalPeriod = 'FiscalPeriods',
    UserPosition = 'UserPositions',
    AutoIncrementer = 'AutoIncrementers',
}

export enum PFLoadEntities {
    Load = 'Loads',
    LoadUnified = 'LoadsUnified',
    Stop = 'Stops',
    Trips = 'Trips',
    Lanes = 'Lanes',
    LaneGroups = 'LaneGroups',
    Rates = 'Rates',
    RateCharges = 'RateCharges',
    Quotes = 'Quotes',
    StopItem = 'StopItems',
    StopCharge = 'StopCharges',
    ItemCharges = 'ItemCharges',
    LaneCarriers = 'LaneCarriers',
    LoadSchedule = 'RecurringLoadSchedules',
    LoadScheduleSummary = 'LoadScheduleSummary',
    Lane = 'Lane',
    LaneRate = 'LaneRate',
    ItemCharge = 'ItemCharge',
    LaneCarrier = 'LaneCarrier',
    LoadWorkflow = 'LoadWorkflow',
    WorkflowGlobalParameter = 'WorkflowGlobalParameter',
}

export enum PFTransportationEntities {
    Driver = 'Driver',
    Vehicle = 'Vehicle',
    Trailer = 'Trailer',
    Equipment = 'Equipment',
    Mode = 'Modes',
    Service = 'Service',
}

export enum PFWmsEntities {
    InventoryBundle = 'InventoryBundles',
    InventoryAdjustment = 'InventoryAdjustments',
    Shipment = 'Shipments',
    Container = 'Containers',
    PackingList = 'PackingLists',
    PackLine = 'PackLine',
    InventoryClaim = 'InventoryClaims',
    PickList = 'PickLists',
    Pick = 'Picks',
    PutAway = 'PutAways',
    PutAwayList = 'PutAwayLists',
    InventoryReceipt = 'InventoryReceipts',
    Slot = 'Slots',
    Zone = 'Zones',
    Warehouse = 'Warehouses',
    WarehouseItemSetting = 'WarehouseItemSettings',
    CycleCount = 'CycleCounts',
    Project = 'Projects',
    ProjectLineItem = 'ProjectLineItems',
    Exception = 'Exceptions',
    Audit = 'Audits',
    Replenishment = 'Replenishments',
    Equipment = 'Equipment',
    ReceiptHeader = 'ReceiptHeaders',
    ReceiptLine = 'ReceiptLines',
    AsnHeader = 'AsnHeaders',
    AsnLine = 'AsnLines',
    Requisition = 'Requisitions',
    RequisitionLine = 'RequisitionLines',
}

export enum PFOrdersEntities {
    PurchaseOrderHeader = 'PurchaseOrderHeaders',
    PurchaseOrderLine = 'PurchaseOrderLines',
}

export enum PFYmsEntities {
    DockArea = 'DockArea',
    Dock = 'Dock',
    ExceptionResolution = 'ExceptionResolution',
    Exception = 'Exception',
    Gate = 'Gate',
    Schedule = 'Schedule',
    Spot = 'Spot',
    VisitOperationItem = 'VisitOperationItem',
    VisitOperation = 'VisitOperation',
    Visit = 'Visit',
    YardAllowance = 'YardAllowance',
    YardArea = 'YardArea',
    Yard = 'Yard',
}

export enum PFItemCatalogEntities {
    Item = 'Items',
    Category = 'Categories',
}

export enum PFCommunicationsEntities {
    OneTimeLink = 'OneTimeLinks',
}

export enum PlatformModules {
    PlatformCommunications = 'Communications',
    PlatformCore = 'Core',
    PlatformItemCatalog = 'Item-Catalog',
    PlatformLoads = 'Loads',
    PlatformOrders = 'Orders',
    PlatformTransportation = 'Transportation',
    PlatformWms = 'WMS',
    PlatformYms = 'YMS',
}

export enum PermissionTypes {
    Read = 'Read',
    Modify = 'Modify',
    Admin = 'Admin',
}
